import { withInstall } from '../_util'

import Modal from './Modal'
import ModalLocator from './ModalLocator.vue'

export default withInstall<typeof Modal, { ModalLocator: typeof ModalLocator }>(Modal, { ModalLocator })

export { default as useOModal } from './useModal'
